import React, { useContext, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { AppContext } from "contexts/AppContext";
import { createUseStyles } from 'react-jss'
import { Box } from '@mui/material';
import { translate } from 'utils/Translate';
import Activity from 'utils/Activity';
import { callAPI } from 'utils/API';
import ContentNormal from 'components/elements/ContentNormal';
import Headline4 from 'components/elements/Headline4';
import { Modal } from 'react-bootstrap';

const jss = createUseStyles({
    GodkendButton: {
        backgroundColor: (styleGuide) => styleGuide.color16,
        color: '#ffffff'
    },
    DialogButton: {
        color: '#ffffff',
        height: 48,
        borderRadius: 4,
        border: 'none',
        padding: '0px 24px',
        fontWeight: 500,
        fontFamily: 'Poppins',
        fontSize: 16,
    },
    "@media screen and (max-width: 768px)": {
        DialogButton: {
            fontSize: 14,
        },
    },
    MitIdButton: {
        backgroundColor: '#0060E6',
        '@media (hover: hover)':{
            '&:hover':{
                backgroundColor: '#004CB8',
            }
        },
        '&:disabled':{
            backgroundColor: (styleGuide) => styleGuide.color4,
        },
    },
    CancelButton: {
        backgroundColor: (styleGuide) => styleGuide.color4,
        '@media (hover: hover)':{
            '&:hover':{
                backgroundColor: (styleGuide) => styleGuide.color5,
            }
        },
    },
})

export const CprMitIdPopUp = () => {
    const { styleGuide, brandData, langCode } = useContext(AppContext);
    const [consent, setConsent] = useState(false);
    const [showCPRModal, setShowCPRModal] = useState(false);
    const [cprStatus, setCprStatus] = useState('NONE');
    const navigate = useNavigate();
    const location = useLocation();
    const classes = jss(styleGuide)
    const CPRPopupLabels = brandData.features?.upgraderClubConfigurableLabels && brandData.features.upgraderClubConfigurableLabels[langCode]?.homePageLabels?.CPRPopupLabels
        ? brandData.features.upgraderClubConfigurableLabels[langCode].homePageLabels.CPRPopupLabels : null

    const getMitIdAuthUrl = async () => {
        Activity({activityType: 'click', activityName: 'Home' ,activityArgument: 'CPR', activityArgumentID: ''})
        const callbackUrl = window.location.origin
        const response = await callAPI("/cpr/getAuthenticationUrl", "POST", {
            body: {
                callbackUrl: callbackUrl,
            }
        })
        if (response && !response.error ) {
            window.location.href = response
        } else {
            // Do nothing - user can try again
        }
    }

    const updateConsent = (e) => {
        setConsent(e.target.checked)
    }

    const getUserCPR = async () => {
        let cprStatus = await callAPI("cpr/getUserCprStatus", "GET")
        if (cprStatus === 'EXISTS') {
            setShowCPRModal(false)
        } else {
            setShowCPRModal(true)
        }
        setCprStatus(cprStatus)
    }

    const clearSession = () => {
        localStorage.clear()
        navigate('/logout')
    }

    const closeCPRModal = () => {
        setShowCPRModal(false)
        clearSession();
    }

    useEffect(() => {
        getUserCPR()
    }, [location])

    const termsLink = <a
        rel='noopener noreferrer'
        style={{ color: '#0056b3' }}
        href={CPRPopupLabels?.CPRPopUpTermsURL ? CPRPopupLabels.CPRPopUpTermsURL : brandData && brandData.features && brandData.features.CPRPopUpTermsURL ? brandData.features.CPRPopUpTermsURL : '_blank'}
        target='_blank'
    >
        {' '} {CPRPopupLabels?.CPRPopUpTermsLinkText ? CPRPopupLabels.CPRPopUpTermsLinkText : translate('_CPR_CONDITIONS_LINK_TEXT_', 'betingelser')}.
    </a>

    return (
        <Modal
            show={showCPRModal}
            centered
            size='lg'
            style={{zIndex: 2000}}
        >
            <Modal.Body dividers>
                <Box padding={2}>
                    <Headline4>
                        {cprStatus === 'NONE' || cprStatus === 'REMOVED' ? translate('_CONFIRM_YOUR_CPR_', 'Bekræft dit CPR-nummer') : translate('_RECONFIRM_YOUR_CPR_', 'Genbekræft dit CPR-nummer')}
                    </Headline4>
                    <Box style={{marginTop: 15}}>
                        {cprStatus === 'NONE' || cprStatus === 'REMOVED' ?
                            <ContentNormal>
                                {translate('_CPR_MITID_APPROVAL_TEXT_1_', `For at logge ind første gang skal du bekræfte dit CPR-nummer. Herefter skal det genbekræftes én gang om året via MitID. Dine point bliver først skattepligtige, når du aktiverer dem. `)}
                                {translate('_CPR_MITID_APPROVAL_TEXT_2_', `Indtil da sker der ingen indberetning til SKAT. Når du aktiverer dine point, bliver deres værdi automatisk indberettet til SKAT via systemet. Du kan derfor trygt bekræfte dit CPR-nummer. Læs mere i `)}
                                {termsLink}
                            </ContentNormal>
                            :
                            <ContentNormal>
                                {translate('_CPR_OUTDATED_TEXT_1_', `Af sikkerhedshensyn skal du én gang om året bekræfte dit CPR-nummer via MitID. Det sikrer korrekt indberetning til SKAT, når du aktiverer dine point. Pointene er ikke skattepligtige, før de aktiveres - og indberettes først derefter. `)}
                                {translate('_CPR_OUTDATED_TEXT_2_', `Du kan derfor trygt genbekræfte dit CPR-nummer - det tager kun et øjeblik. Læs mere i `)}
                                {termsLink}
                            </ContentNormal>
                        }
                    </Box>
                    <Box style={{marginTop: 20}}>
                        <ContentNormal
                            style={{
                                fontWeight: 'bold',
                            }}
                        >
                            <input type='checkbox'
                                value={consent}
                                onChange={(e) => updateConsent(e)}
                                style={{ marginRight: '12px' }} />
                            {CPRPopupLabels?.CPRPopUpCheckboxText ? CPRPopupLabels.CPRPopUpCheckboxText : brandData && brandData.features && brandData.features.CPRPopUpCheckboxText ? brandData.features.CPRPopUpCheckboxText : translate('_CPR_AGREE_CHECKBOX_TEXT_', `Jeg accepterer, at værdien af mine aktiverede point indberettes til SKAT.`)}
                        </ContentNormal>
                    </Box>
                </Box>
            </Modal.Body>
            <Modal.Footer>
                <Box paddingLeft={0} paddingRight={0} display={'flex'} gap={2} flexWrap={'wrap'} justifyContent={'end'}>
                    {!!consent &&
                        <button
                            className={`${classes.DialogButton} ${classes.MitIdButton}`}
                            onClick={getMitIdAuthUrl}
                            disabled={!consent}
                        >
                            <div style={{display: 'flex'}}>
                                <img
                                    className='mitIdLogo'
                                    src='/mitid.svg'
                                    width={70}
                                    height='auto'
                                />
                                <span style={{marginTop: 2, marginLeft: 16}}>{translate('_CONFIRM_WITH_MITID_', 'Bekræft med MitID')}</span>
                            </div>
                        </button>
                    }
                    <button
                        className={`${classes.DialogButton} ${classes.CancelButton}`}
                        onClick={() => closeCPRModal()}
                    >
                        {translate('_CANCEL_', 'Afvis')}
                    </button>
                </Box>
            </Modal.Footer>
        </Modal>
    );
}


